module.exports = __webpack_public_path__ + "static/media/scene_cafe.99a501e5.jpg";